import { useMemo } from "react";
import { useSelector } from "react-redux";
import { CareComment } from "../../../domain/care_comment/CareComment";
import { CareCommentThread } from "../../../domain/care_comment/CareCommentThread";
import { CareCommentThreadId } from "../../../domain/care_comment/CareCommentThreadId";
import { CareCommentContent } from "../../../domain/care_comment/CareCommentContent";
import { CareCommentId } from "../../../domain/care_comment/CareCommentId";
import { CareCommentTitle } from "../../../domain/care_comment/CareCommentTitle";
import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { DateTime } from "../../../domain/fundamental/DateTime";
import { State } from "../../../state/store";

export const useCareCommentThreadList = (): CareCommentThread[] | null => {
    const jsonArray = useSelector((state: State) => state.careComment.careCommentThreadList);

    const array = useMemo(() => (
        jsonArray?.map(it => CareCommentThread.from(
            CareCommentThreadId.fromString(it.id),
            CareRecipientId.fromString(it.careRecipientId),
            DateTime.fromString(it.createdTime),
            it.careCommentList.map(careCommentJson => CareComment.from(
                CareCommentId.fromString(careCommentJson.id),
                CareRecipientId.fromString(it.careRecipientId),
                CareCommentTitle.fromString(careCommentJson.title),
                CareCommentContent.fromString(careCommentJson.content),
                DateTime.fromString(careCommentJson.createdTime),
                careCommentJson.isRead
            )),
            it.isPinned
        )) ?? null
    ), [jsonArray]);

    return array ? array.sort((thread, nextThread) => DateTime.sortDesc(thread.careComments.slice(-1)[0].createdTime, nextThread.careComments.slice(-1)[0].createdTime)) : null;
};